import ExcelJS from 'exceljs';
import * as Sentry from '@sentry/react';

/**
 * Exporta datos a un archivo Excel
 * @param {Array} data - Array de objetos con los datos a exportar
 * @param {string} fileName - Nombre del archivo Excel (sin extensión)
 * @param {string} sheetName - Nombre de la hoja de cálculo (opcional, por defecto 'Datos')
 */
export const exportToExcel = async (data, fileName, sheetName = 'Datos') => {
  try {
    // Crear un nuevo workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    if (!data || data.length === 0) {
      throw new Error('No hay datos para exportar');
    }

    // Obtener las columnas del primer objeto
    const columns = Object.keys(data[0]);
    
    // Configurar las columnas del worksheet
    worksheet.columns = columns.map(key => ({
      header: key,
      key: key,
      width: 15
    }));

    // Agregar los datos
    data.forEach(row => {
      worksheet.addRow(row);
    });

    // Estilizar el header
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '366092' }
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Aplicar bordes a todas las celdas con datos
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) { // Saltar el header
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
          cell.alignment = { horizontal: 'left', vertical: 'middle' };
        });
      }
    });

    // Generar el buffer del archivo
    const buffer = await workbook.xlsx.writeBuffer();
    
    // Crear un blob y descargar el archivo
    const blob = new Blob([buffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

